import { APIProvider } from '@vis.gl/react-google-maps';
import Theme from './theme';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string}>
      <Theme>
      {children}
      </Theme>
    </APIProvider>
  );
}